import * as React from 'react';

export type HeroImageExperimentVariant = 'control' | 'image';

export type HeroImageExperimentContextType = {
  experimentVariant: HeroImageExperimentVariant;
  // Non-null only when the variant is 'image' and the current product's slug is in the image
  // treatment's fixed slug list. HeroModule renders the image only when this is set.
  heroImageUrl: string | null;
};

const HeroImageExperimentContext = React.createContext<HeroImageExperimentContextType>({
  experimentVariant: 'control',
  heroImageUrl: null,
});

export const useHeroImageExperiment = () => {
  return React.useContext(HeroImageExperimentContext);
};

export default HeroImageExperimentContext;
